<h1
  class="text-2xl font-bold mx-4 sm:mx-14 my-7"
  *ngIf="!showOnlyUSDT && !showOnlyUSDTSale"
>
  Formas de actualización
</h1>
<div class="mx-4 sm:mx-14">
  <ng-container *ngIf="showOnlyUSDT && !showOnlyUSDTSale">
    <h2 class="text-lg font-bold mb-4">Tasa USDT</h2>
    <mat-button-toggle-group class="grupo-toggles"
      [(ngModel)]="usdtType"
      (change)="change('ACTUALIZACION_USDT', usdtType)"
      [disabled]="!puedeEditar"
      aria-label="Forma de actualización de la tasa USDT"
    >
      <mat-button-toggle value="AUTOMATICO">Automática</mat-button-toggle>
      <mat-button-toggle value="MANUAL">Manual</mat-button-toggle>
    </mat-button-toggle-group>
    <p *ngIf="!puedeEditar" class="motivo-sin-permiso">
      <mat-icon aria-hidden="true">lock</mat-icon>{{ textoSinPermiso }}
    </p>
  </ng-container>

  <div
    *ngIf="showOnlyUSDT"
    [class.max-w-full]="showOnlyUSDT"
    class="rounded-[40px] border-4 shadow-2xl border-lime-900 max-w-[220px] mt-8 text-center"
  >
    <p class="text-2xl font-bold mt-10 my-4 mx-4">
      {{ autoRate | number : "1.2-2" }} USDT
    </p>
    <p class="text-md italic mb-4 mx-4">Tasa Automatica</p>
    <button
      mat-fab
      extended
      color="secondary"
      matTooltip="Refrescar Tasa"
      aria-label="Refrescar Tasa"
      (click)="getAutoRate()"
      class="text-aguacate-green h-[56px] w-1/5 md:w-[160px] button-search leading-6 mb-4"
    >
      <span class="hidden md:block">Refrescar</span>
      <mat-icon class="">refresh</mat-icon>
    </button>
  </div>
  <div
    *ngIf="showOnlyUSDTSale"
    [class.max-w-full]="showOnlyUSDTSale"
    class="rounded-[40px] border-4 shadow-2xl border-lime-900 max-w-[220px] mt-8 text-center"
  >
    <p class="text-2xl font-bold mt-10 my-4 mx-4">
      {{ autoRateSales | number : "1.2-2" }} USDT
    </p>
    <p class="text-md italic mb-4 mx-4">Tasa Automatica Ventas</p>
    <button
      mat-fab
      extended
      color="secondary"
      matTooltip="Refrescar Tasa"
      aria-label="Refrescar Tasa"
      (click)="getAutoRateSales()"
      class="text-aguacate-green h-[56px] w-1/5 md:w-[160px] button-search leading-6 mb-4"
    >
      <span class="hidden md:block">Refrescar</span>
      <mat-icon class="">refresh</mat-icon>
    </button>
  </div>
</div>
<ng-container *ngIf="!showOnlyUSDT && !showOnlyUSDTSale">
  <div class="mx-4 sm:mx-14 mt-4">
    <h2 class="text-lg font-bold mb-4">Tasa Fiat</h2>
    <mat-button-toggle-group class="grupo-toggles"
      [(ngModel)]="fiatType"
      (change)="change('ACTUALIZACION_VES', fiatType)"
      [disabled]="!puedeEditar"
      aria-label="Forma de actualización de la tasa Fiat"
    >
      <mat-button-toggle value="AUTOMATICO">Binance</mat-button-toggle>
      <mat-button-toggle value="MANUAL">Manual</mat-button-toggle>
      <mat-button-toggle value="CBPAY">CBPAY</mat-button-toggle>
    </mat-button-toggle-group>
    <p *ngIf="!puedeEditar" class="motivo-sin-permiso">
      <mat-icon aria-hidden="true">lock</mat-icon>{{ textoSinPermiso }}
    </p>
  </div>
  <div class="mx-4 sm:mx-14 mt-4">
    <h2 class="text-lg font-bold mb-4">Pago de transacciones Fiat</h2>
    <mat-button-toggle-group class="grupo-toggles"
      [(ngModel)]="fiatPaymentType"
      (change)="change('FIAT_AUTOMATICO', fiatPaymentType)"
      aria-label="Pago de transacciones Fiat"
    >
      <mat-button-toggle value="MANUAL">Manual</mat-button-toggle>
      <mat-button-toggle value="CBPAY">CBPAY</mat-button-toggle>
    </mat-button-toggle-group>
  </div>
</ng-container>
